import { LiteralExpression } from './LiteralExpression.js';
export class StringExpression extends LiteralExpression {
    parseValue(value) {
        return value.replace(/"|'/g, '');
    }
}
//# sourceMappingURL=StringExpression.js.map